import { ChevronUp, ChevronDown } from '@gympass/yoga-icons';

import Tooltip from 'components/Tooltip';

import { SortHeaderProps } from './types';

import * as S from './styles';

const SortHeader: React.FC<SortHeaderProps> = ({
  selected = false,
  direction = 'ASC',
  children,
  column,
  onClick,
}) => {
  const handleClick = () => {
    if (selected) {
      const newDirection = direction === 'ASC' ? 'DESC' : 'ASC';
      onClick(column, newDirection);
    } else {
      onClick(column, direction);
    }
  };

  const sortIcon = (
    <S.Icon>
      <ChevronUp />
      <ChevronDown />
    </S.Icon>
  );

  const getTooltipText = () => {
    if (!column.sortTooltip) {
      return '';
    }

    const { enable, ascText = '', descText = '' } = column.sortTooltip;

    if (!enable) {
      return '';
    }

    return direction === 'ASC' ? ascText : descText;
  };

  if (!column.sortable) {
    return <S.NoSortable>{children}</S.NoSortable>;
  }

  if (!selected) {
    return (
      <S.Container data-testid="no-selected-container">
        <S.NoSelected onClick={handleClick} data-testid="no-selected-button">
          {children}
          {sortIcon}
        </S.NoSelected>
      </S.Container>
    );
  }

  return (
    <S.Container data-testid="selected-container">
      <Tooltip description={getTooltipText()}>
        <S.SortContainer data-testid="sort-container" onClick={handleClick}>
          {children}
          {sortIcon}
        </S.SortContainer>
      </Tooltip>
    </S.Container>
  );
};

export default SortHeader;
